import { render } from "./MalawiChapter.vue?vue&type=template&id=45d226c8"
import script from "./MalawiChapter.vue?vue&type=script&lang=js"
export * from "./MalawiChapter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__